import React, { useState, useEffect, useCallback, useRef } from "react";
import { toast } from "sonner";
import axios from "axios";
import MapDashboard from "./MapDashBoard/MapDashboard";
import MapDashboardOld from "./MapDashBoardOld/MapDashboardOld";
import { useGlobalContext } from "../../GlobalContext";
import { AnimatePresence, motion } from "framer-motion";
import useShop from "../../Sevices/useShop";
import useTasks from "../../Sevices/useTasks";
import useDriverAllApi from "../../Sevices/Driver Api/useDriverAllApi";

export default function DashboardContainer() {
  const {
    baseurl,
    token,
    accessToken,
    ApiCall,
    setIsUnauthorised,
    socketData,
    AdminId,
  } = useGlobalContext();

  const {
    shops,
    loading: shopsLoading,
    fetchShops,
  } = useShop({
    baseurl,
    accessToken,
    token,
    AdminId,
    setIsUnauthorised,
  });

  const { fetchTasks } = useTasks();

  const [tasks, setTasks] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isAutoAssignChecked, setIsAutoAssignChecked] = useState(true);
  const [autoAssignLoading, setAutoAssignLoading] = useState(false);
  const { showOld, setShowOld } = useGlobalContext();
  const [selectedTeam, setSelectedTeam] = useState("All Team");
  const { teams, fetchDriverTeams, fetchDrivers } = useDriverAllApi();
const [isAddTaskOpen, setIsAddTaskOpen] = useState(false);
const [instructionTaskIds, setInstructionTaskIds] = useState(new Set());

  useEffect(() => {
    const today = new Date();
    const format = (date) => date.toISOString().split("T")[0];
    const todayStr = format(today);

    setToDate(todayStr);
    setFromDate(todayStr);
  }, []);

  // FetchTaskCall

  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = async () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    setLoading(true);

    const payload = {
      configType: "auto_assign_status",
      configValue1: newValue ? "Y" : "N",
      configValue2: "",
      configValue3: "",
      configValue4: "",
      adminId: AdminId,
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/updateAutoAssignConfig`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      }
    } catch (err) {
      console.error("Error updating config:", err);
    } finally {
      setLoading(false);
      ShowToggleStatus();
    }
  };

  const ShowToggleStatus = async () => {
    setLoading(true);
    const payload = {
      configType: "auto_assign_status",
      adminId: AdminId,
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/getAutoAssignConfig`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (
        response.data?.responseCode === "00" &&
        response.data?.data?.configValue
      ) {
        const isOn = response.data.data.configValue === "Y";
        setIsChecked(isOn);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      }
    } catch (err) {
      console.error("Error fetching toggle status:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ShowToggleStatus();
  }, []);

  const SyncWithAnlook = async (taskId) => {
    try {
      const UserDetail = {
        taskId: taskId,
        adminId: AdminId,
      };

      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/syncDeliveryDetailsWithPartner`,
        UserDetail,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          response.data?.responseMessage || "Error syncing with Anlook",
        );
      }
    } catch (error) {
      console.error("Error syncing with Anlook:", error);
      toast.error("Error syncing with Anlook");
    }
  };

  const AssignTaskToDriver = async (taskId, driverId) => {
    if (!taskId || !driverId) {
      toast.error("Task or Driver not selected");
      return;
    }

    const payload = {
      taskId: taskId,
      driverId: driverId,
      adminId: AdminId,
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/assignDriver`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);
        fetchTasks(fromDate, toDate, setTasks);
        return true;
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      } else {
        toast.error(response.data?.responseMessage || "Error assigning driver");
        return false;
      }
    } catch (error) {
      console.error("Error assigning driver:", error);
      toast.error("Error assigning driver");
      return false;
    }
  };

  const fetchTaskLogs = useCallback(
    async (taskId) => {
      const payload = {
        fromDate,
        toDate,
        taskId: taskId.toString(),
        adminId: AdminId,
      };

      try {
        const assignmentRes = await axios.post(
          `${baseurl}/api/Task/v1.0/getTaskAssignmentLogs`,
          payload,
          { headers: { Authorization: `Bearer ${accessToken}` } },
        );

        const statusRes = await axios.post(
          `${baseurl}/api/Task/v1.0/getTaskStatusChangeLogs`,
          payload,
          { headers: { Authorization: `Bearer ${accessToken}` } },
        );

        return {
          assignmentLogs:
            assignmentRes.data?.responseCode === "00"
              ? assignmentRes.data.data || []
              : [],
          statusChangeLogs:
            statusRes.data?.responseCode === "00"
              ? statusRes.data.data || []
              : [],
        };
      } catch (err) {
        console.error("Error fetching logs:", err);
        return { assignmentLogs: [], statusChangeLogs: [] };
      }
    },
    [baseurl, accessToken, fromDate, toDate, AdminId],
  );

  const handleChangeStatus = useCallback(
    async (taskId, newStatus, driverId) => {
      const payload = {
        taskId: taskId.toString(),
        status: newStatus,
        driverId: driverId?.toString() || "0",
        adminId: AdminId,
      };

      try {
        const res = await axios.post(
          `${baseurl}/api/Task/v1.0/changeTaskStatusByPackky`,
          payload,
          { headers: { Authorization: `Basic ${token}` } },
        );

        if (res.data.responseCode === "00") {
          console.log("TASKS loaded:", tasks.length);

          await fetchTasks(fromDate, toDate, setTasks); // refresh tasks
          return true;
        }
        return false;
      } catch (err) {
        console.error("Status change failed", err);
        return false;
      }
    },
    [baseurl, token, AdminId, fetchTasks],
  );

const fetchCustomerInstructions = async () => {
  try {
    const payload = {
      adminId: String(AdminId),
      fromDate,
      toDate,
    };

    const res = await axios.post(
      `${baseurl}/api/DriverTracker/v1.0/getCustomerAllTaskInstructionByDate`,
      payload,
      { headers: { Authorization: `Basic ${token}` } }
    );

    if (res.data.responseCode === "00") {
      const ids = new Set();

      (res.data.data || []).forEach((i) => {
        ids.add(String(i.task_id));
      });

      setInstructionTaskIds(ids); 
    }

    return res.data?.data || []; 
  } catch (err) {
    console.error("Instruction fetch error:", err);
    return [];
  }
};

  useEffect(() => {
    if (fromDate && toDate) {
      fetchTasks(fromDate, toDate, setTasks);
    }
  }, [fromDate, toDate]);

  useEffect(() => {
  if (!AdminId) return;

  const loadInitialData = async () => {
    await fetchShops();
    await fetchDriverTeams();
    const driverList = await fetchDrivers(true);
    if (Array.isArray(driverList)) {
      setAgents(driverList);
    }
  };

  loadInitialData();
}, [AdminId]);

const instructionRef = useRef(false);

useEffect(() => {
  if (!AdminId || !fromDate || !toDate) return;
  if (instructionRef.current) return;

  instructionRef.current = true;

  fetchCustomerInstructions();
}, [AdminId, fromDate, toDate]);

useEffect(() => {
  if (!socketData) return;

  const msg = socketData?.Message || "";
  console.log(" SOCKET EVENT:", msg);

  //  CASE 1: TASK STATUS CHANGE 
  if (
    msg.includes("Task Status Changed") ||
    msg.includes("Task Assigned") ||
    msg.includes("Task Updated")
  ) {
    // console.log(" Auto refreshing TASKS due to WebSocket...");

    if (fromDate && toDate) {
      fetchTasks(fromDate, toDate, setTasks);
    }
  }

  // CASE 2: CUSTOMER INSTRUCTION UPDATED 
  if (msg.includes("customer instruction updated")) {
    const taskId = msg.split("updated ")[1];
    // console.log(" Instruction updated for task:", taskId);

    fetchCustomerInstructions();
  }
}, [socketData]);

  const commonProps = {
    tasks: tasks,
    agents: agents,
    loading: loading,
    isLoading: isLoading,
    fromDate: fromDate,
    toDate: toDate,
    shops: shops,
    isAutoAssignChecked: isAutoAssignChecked,
    autoAssignLoading: autoAssignLoading,
    teams: teams,
    selectedTeam: selectedTeam,
    setSelectedTeam: setSelectedTeam,
    setFromDate: setFromDate,
    setToDate: setToDate,
    fetchTasks,
    FetchDriverCall: fetchDrivers,
    SyncWithAnlook: SyncWithAnlook,
    AssignTaskToDriver: AssignTaskToDriver,
    handleToggle: handleToggle,
    ShowToggleStatus: ShowToggleStatus,
    isChecked,
    fetchTaskLogs,
    handleChangeStatus,
    setIsChecked,
    baseurl: baseurl,
    token: token,
    accessToken: accessToken,
    setIsUnauthorised: setIsUnauthorised,
    showOld: showOld,
    setShowOld: setShowOld,
    isAddTaskOpen,
setIsAddTaskOpen,
instructionTaskIds,
  fetchCustomerInstructions,
  };

  const direction = showOld ? 1 : -1;

  const slideVariants = {
    enter: (dir) => ({
      x: `${dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    }),
    center: {
      x: "0%",
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    exit: (dir) => ({
      x: `${-dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    }),
  };

  return (
    <div className="h-full relative flex-1 overflow-hidden">
      <AnimatePresence custom={direction}>
        <motion.div
          key={showOld ? "old" : "new"}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            type: "spring",
            stiffness: 320,
            damping: 32,
            mass: 0.8,
          }}
          className="h-full"
        >
          {showOld ? (
            <MapDashboardOld {...commonProps} />
          ) : (
            <MapDashboard {...commonProps} />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
